import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetNextAvailability, HttpGetNextAvailabilityOptions} from '../http/agenda.http'
import {ConsultantNextAvailability} from '@/features/agenda/types'

export const useGetNextAvailability = (
    params: HttpGetNextAvailabilityOptions['params'],
    options?: Omit<UseQueryOptions<ConsultantNextAvailability[]>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        ...options,
        queryKey: [QUERY_KEYS.AGENDA_AVAILABILITIES, params],
        queryFn: () => httpGetNextAvailability({params})
    })
}
